export default {
    name: "menu_items",
    items: [{
        label: "Home",
        icon:"mdi-home-city-outline",
        to: "/home",
        roles: ["super role","public","backofficcee","owner"]
    },{
        label: "Search",
        icon:"mdi-card-search-outline",
        to: "/search",
        roles: ["super role","public","backofficcee","owner"]
    },{
        label: "Promotions",
        icon:"mdi-cart-arrow-up",
        to: "/promotions",
        roles: ["super role","public","backofficcee","owner"]
    },{
        label: "Directory",
        icon:"mdi-format-list-text",
        to: "/directory",
        roles: ["super role","public","backofficcee","owner"]
    },{
        label: "Categories",
        icon:"mdi-group",
        to: "/categories",
        roles: ["super role","public","backofficcee","owner"]
    },{
        label: "Admin",
        icon:"mdi-account-cog",
        to: "/admin",
        roles: ["super role","backofficcee"]
    },{
        label: "My Account",
        icon:"mdi-account-cash",
        to: "/owner",
        roles: ["super role","backofficcee","owner"]
    }]
}